export function SheetException(message) {
    this.name = "SheetException";
    this.message = message;
}
